import { Routes } from './public';

export const AppRoutes = () => {
  // const element = useRoutes(publicRoutes);

  return <Routes />;
};
